import { render, staticRenderFns } from "./subjects.page.vue?vue&type=template&id=3cd26374&scoped=true&"
import script from "./subjects.page.js?vue&type=script&lang=js&"
export * from "./subjects.page.js?vue&type=script&lang=js&"
import style0 from "./subjects.page.scss?vue&type=style&index=0&id=3cd26374&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd26374",
  null
  
)

export default component.exports